export const filterByValue = (arr, propertyToFilterBy, searchValue) => {
    let newArr = [...arr];
    newArr = newArr.filter(item => {
        if(item[propertyToFilterBy]) {
            return item[propertyToFilterBy].toLowerCase().includes(searchValue.toLowerCase());
        }
    })
    return newArr;
}

